import { Component, Vue } from "vue-property-decorator";
import { Roles } from "./enums";
import { RouteNames } from "@/router";

@Component({
    components: {},
})
export default class App extends Vue {
    public RouteNames = RouteNames;

    public get username(): string {
        return this.$store.getters["account/username"];
    }

    get isAdmin(): boolean {
        return this.$store.getters["account/user"]?.roleId === Roles.Administrator;
    }

    get isNotMember(): boolean {
        return this.$store.getters["account/user"]?.roleId !== Roles.Member;
    }

    public get isActive(): boolean {
        return this.$store.getters["account/user"]?.isActive;
    }

    public get isRegistered(): boolean {
        return this.$store.getters["account/isRegistered"];
    }
}
